/**
 * Trouve ou crée une balise meta theme-color et définit sa couleur
 * @param {string} color - La couleur au format hexadécimal (ex: '#ffffff')
 * @returns {HTMLMetaElement} La balise meta theme-color
 */
export function setBrowserThemeColor(color) {
  // Validation du format de couleur
  if (!color || !/^#([0-9A-F]{3}){1,2}$/i.test(color)) {
    return null
  }

  // Recherche de la balise meta theme-color existante
  let metaThemeColor = document.querySelector('meta[name="theme-color"]')

  // Si la balise n'existe pas, on la crée
  if (!metaThemeColor) {
    metaThemeColor = document.createElement('meta')
    metaThemeColor.setAttribute('name', 'theme-color')
    document.head.appendChild(metaThemeColor)
  }

  // Définition de la couleur
  metaThemeColor.setAttribute('content', color)

  return metaThemeColor
}
